import { render, staticRenderFns } from "./app-menu.vue?vue&type=template&id=68a02527&scoped=true&"
import script from "./app-menu.vue?vue&type=script&lang=js&"
export * from "./app-menu.vue?vue&type=script&lang=js&"
import style0 from "./app-menu.vue?vue&type=style&index=0&id=68a02527&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a02527",
  null
  
)

export default component.exports